import { h } from 'preact'
import AspectImage from '@ui/AspectImage'

export default function CategoryBox({
    category,
    showDescription,
}) {
    return (
        <a className="subCategories__item" href={category.seName ?? category.url}>
            {(category.pictureModel && category.pictureModel.imageUrl) && (
                <div className="picture">
                    <AspectImage
                        aspectRatio={{ x: 16, y: 9 }}
                        title={category.pictureModel.title}
                        alt={category.pictureModel.alternateText}
                        src={category.pictureModel.imageUrl}
                    />
                </div>
            )}
            
            <div className="content">
                <span className="category-title">{category.name}</span>

                {showDescription && category.description && (
                    <div className="description">
                        <span>{category.description}</span>
                    </div>
                )}
            </div>
        </a>
    )
}
